import {changelogCardTitle, changelogTheme} from '@/Components/Changelogs/changelogTheme.js';
import ChangelogMarkdown from '@/Components/Changelogs/ChangelogMarkdown.jsx';
import ChangelogOutlinedBox from '@/Components/Changelogs/ChangelogOutlinedBox.jsx';
import Modal from '@/Components/Common/Modal.jsx';
import {Box, Button, Stack, ThemeProvider} from '@mui/material';
import * as React from 'react';

const PatchNoteModal = ({open, changelog, onClose}) => {
    if (!changelog) {
        return null;
    }

    return (
        <ThemeProvider theme={changelogTheme(changelog.color_theme)}>
            <Modal
                maxWidth={'md'}
                open={open}
                onClose={() => {}} // Désactive la fermeture en cliquant à l'extérieur
                scroll={'paper'}
                fullWidth={true}
                disableEscapeKeyDown={true} // Désactive la fermeture avec la touche Échap
                title={<>Nouveautés</>}
                TitleProps={{
                    component: 'div',
                    variant: 'h2',
                    sx: {
                        fontWeight: 400,
                        p: 2,
                        mb: 0,
                        textAlign: 'center',
                    },
                }}
            >
                <Stack spacing={3} sx={{my: 2}}>
                    <ChangelogOutlinedBox title={changelogCardTitle(changelog)} colorTheme={changelog.color_theme}>
                        <ChangelogMarkdown>{changelog.body}</ChangelogMarkdown>
                    </ChangelogOutlinedBox>

                    <Box sx={{display: 'flex', justifyContent: 'center', pt: 2}}>
                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            onClick={onClose}
                            sx={{
                                minWidth: 200,
                                py: 1.5,
                                fontSize: '1.1rem',
                                fontWeight: 600,
                            }}
                        >
                            J'ai pris connaissance des modifications
                        </Button>
                    </Box>
                </Stack>
            </Modal>
        </ThemeProvider>
    );
};

export default PatchNoteModal;
